import styled from "@emotion/styled";
import mixins from "theme/mixins";

// styled-components
export const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 1rem;

  ${mixins.media.tablet`
      flex-direction: column;
      justify-content: flex-end;
    `};
`;

export const LeftSide = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;

  & > div {
    margin-right: 10px;
  }
`;

export const RightSide = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  ${mixins.media.tablet`
      justify-content: flex-end;
    `};
`;
